module.exports = __webpack_public_path__ + "static/media/Michaela D. Cuellar.61080c66.jpg";